import ConfirmationDialog from '../../../../../../../components/dialog/ConfirmationDialog';

const AllowCustomResponseConfirmation = ({
  open,
  onConfirm,
  onClose,
} = {
  open: false,
  onConfirm: () => null,
  onClose: () => null,
}) => (
  <ConfirmationDialog
    open={open}
    title='Allow custom response'
    contentText='Are you sure you want to change to Custom Student Response?'
    confirmLabel='Yes'
    cancelLabel='No'
    onConfirm={onConfirm}
    onCancel={onClose}
  />
);

export default AllowCustomResponseConfirmation;
